import { accountRetailerService } from '@/projects/platform/services/account-retailer-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { t } from 'i18next';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const App = () => {
  const statusStore = [
    { id: true, name: 'Verified' },
    { id: false, name: 'Unverified' },
  ];

  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData };
  };

  const handleInitNewRow = async (e: any) => {
    e.data.isVerified = false;
  };

  const store = createCustomStore({
    key:["id"],
    load: accountRetailerService.listEmails,
    insert: accountRetailerService.createEmail,
    update: accountRetailerService.updateEmail,
    remove: accountRetailerService.deleteEmail,
    byKey: (key, loadOptions) => {
        if (key) {
            loadOptions.filter = ["Id", "=", key];
        }
    },
});

  return (
    <DataGridWrapper
      datasource={store}
      columns={[
        {
          dataField: "name",
          caption: t("email_name"),
          required: true,
          requiredMessage: t("email_name_is_required"),
        },
        {
          dataField: "emailAddress",
          caption: t("email"),
          required: true,
          requiredMessage: t("email_is_required"),
        },
        {
          dataField: "description",
          caption: t("description"),
        },
        {
          dataField: "isVerified",
          caption: t("status"),
          allowEditing: false,
          lookup: {
            dataSource: statusStore,
            valueExpr: "id",
            displayExpr: "name",
          },
        }
      ]}
      onRowUpdating={handleRowUpdating}
      onInitNewRow={handleInitNewRow}
      pagerVisible={true}
      filterVisible={true}
      headerFilterVisible={true}
      props={{ id: "email-list-grid" }}
    />
  );
};

export default App;
